<!-- /CONTACT US -->
<!-- <div class="progress">
    <div class="progress-value">
    </div>
</div> -->

<div class="m-page-loader m-page-loader--non-block" style="margin-left: -80px; margin-top: -20px;">
    <div class="m-blockui">
        <span>
            Please wait...
        </span>
        <span>
            <div class="m-loader m-loader--primary"></div>
        </span>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/auth/validateSignUp/validateSignUp.component.html